import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import sandipDalviPhoto from "../../../../assets/CEO_Photos/Sandip_Dalvi.png";

const BoardMemberCard = () => {
  return (
    <StyledBoardMemberCard>
      <Helmet>
        <title>Sandip Dalvi - Founder &amp; Managing Director | NexTech PLM Solutions</title>
        <meta name="description" content="Profile of Sandip Dalvi, Founder, Chairman and Managing Director at NexTech PLM Solutions, with 18+ years of Teamcenter expertise and business leadership experience." />
        <meta name="keywords" content="Sandip Dalvi NexTech PLM, PLM founder Pune, Teamcenter expert India, NexTech PLM managing director, PLM business leader" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/about/board-of-directors/sandip-dalvi" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="profile" />
        <meta property="og:title" content="Sandip Dalvi - Founder & Managing Director | NexTech PLM Solutions" />
        <meta property="og:description" content="Profile of Sandip Dalvi, Founder, Chairman and Managing Director at NexTech PLM Solutions, with 18+ years of Teamcenter expertise." />
        <meta property="og:url" content="https://nextechplm.com/about/board-of-directors/sandip-dalvi" />
        <meta property="og:image" content="https://nextechplm.com/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sandip Dalvi - Founder & Managing Director | NexTech PLM Solutions" />
        <meta name="twitter:description" content="Profile of Sandip Dalvi, Founder, Chairman and Managing Director at NexTech PLM Solutions, with 18+ years of Teamcenter expertise." />
        <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
      </Helmet>
      <Container>
        <h1>Sandip Dalvi</h1>
        <h5>Founder, Chairman and Managing Director</h5>
        <Content>
          <LeftSide>
            <ProfileImage
              src={sandipDalviPhoto}
              alt="Sandip Dalvi"
            />
            <IconSocial>
              <a
                href="https://in.linkedin.com/in/nextechplm"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-linkedin bg-linkedin"></i>
              </a>
              {/* Replace with Twitter link */}
              <span aria-label="X profile unavailable" role="img">
                <i className="fa-brands fa-x-twitter bg-twitter"></i>
              </span>
            </IconSocial>
          </LeftSide>
          <RightSide>
            <p>
              With a career spanning over 18 years in the Teamcenter
              applications landscape, Sandip has amassed extensive expertise.
              His journey began at Siemens, where he dedicated over 15 years to
              mastering diverse roles in technology and management. His
              proficiency includes product management, team leadership,
              presales, business process consulting, solution design, and
              end-to-end implementation.
            </p>
            <p>
              Sandip is renowned for his strong command of Teamcenter
              technology, adeptly managing implementation projects, upgrades,
              and migrations. His deep techno-functional knowledge spans various
              industry sectors, enabling him to deliver tailored solutions to
              global clients.
            </p>
            <p>
              Currently, Sandip plays a pivotal role at NexTech, driving
              business development strategies, nurturing customer relationships,
              and overseeing comprehensive business operations. His expertise
              and leadership continue to propel the company towards greater
              success.
            </p>
          </RightSide>
        </Content>
      </Container>
    </StyledBoardMemberCard>
  );
};

export default BoardMemberCard;

// Styled Components
const StyledBoardMemberCard = styled.section`
  padding: 1rem 2rem;
  border-radius: 10px;
  max-width: 900px;
  margin: 2rem auto;
`;

const Container = styled.div`
  h1 {
    font-size: 3.1rem;
    font-family: "Space Grotesk", sans-serif;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #07b6f2;
  }

  h5 {
    font-size: 1.3rem;
    font-family: "Jost", sans-serif;
    font-weight: normal;
    margin-bottom: 1.5rem;
    color: #777777;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }

    h5 {
      font-size: 1.1rem;
    }
  }
    @media (max-width: 480px) {
    h1 {
      font-size: 2em;
      text-align: center;
    }
      h5 {
      font-size: 1em;
      text-align: center;
    }
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 2rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 2rem;
  }
`;

const ProfileImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 1rem;
`;

const IconSocial = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  a {
    margin: 0 0.5rem;
    font-size: 1.5rem;
    color: #000;
    transition: color 0.3s;

    &:hover {
      color: #0077b5; /* LinkedIn color */
    }
  }

  .bg-linkedin {
    color: #0077b5;
  }
  .bg-twitter {
    color: #555;
  }
`;

const RightSide = styled.div`
  flex: 1;

  p {
    font-size: 1.2rem;
    font-family: "Jost", sans-serif;
    color: #777777;
    line-height: 2;
    text-align: justify;
  }

  @media (max-width: 768px) {
    p {
      text-align: justify;
    }
  }

  @media (max-width: 480px) {
    p {
      font-size: 1em;
    }
  }

`;
